import React from 'react';

/**
 * Status pill. Uses 10% alpha of the accent color on its own color.
 * Props:
 *   - kind: 'ready' | 'cooldown' | 'banned' | 'quarantined' | 'info' | 'muted'
 *   - label: string (visible text)
 *   - tooltip: optional string (title attribute)
 *   - className: optional extra classes
 */
const STYLES = {
  ready:       'bg-[rgba(164,208,7,0.1)] text-steam-success',
  cooldown:    'bg-[rgba(248,156,14,0.1)] text-steam-warn',
  banned:      'bg-[rgba(217,65,38,0.1)] text-steam-danger',
  quarantined: 'bg-[rgba(217,65,38,0.1)] text-steam-danger',
  info:        'bg-[rgba(102,192,244,0.1)] text-accent',
  muted:       'bg-surface-border/40 text-surface-muted'
};

export default function Pill({ kind = 'info', label, tooltip, className = '' }) {
  const style = STYLES[kind] || STYLES.info;
  return (
    <span
      className={`inline-block text-[10px] font-semibold uppercase tracking-[0.05em] px-2 py-0.5 rounded-[2px] ${style} ${className}`}
      title={tooltip}
    >
      {label}
    </span>
  );
}
